const qiye_id="0";
const qiye_name="0";
const qiye_addr="0";
const qiye_shenfen="0";
const openid="0";
const phone="0";
const name="0";
const locl_url="0";
const denglu_stat=0;
const id_zzh="0";
const nichen = "0";
const guanli_page_data = "0";
const hangye = "";
const yewu = "";

export default{
    qiye_id,
    qiye_name,
    qiye_addr,
    qiye_shenfen,    
    openid,
    phone,
    locl_url,
    name,
    denglu_stat,    
    id_zzh,
    nichen,
    guanli_page_data,
    hangye,
    yewu,
}